import React from 'react';

import SubNavigationSlot from './SubNavigationSlot';
import { SubNavItem } from '../types';

interface SubNavigationProps {
  items?: SubNavItem[];
  onClick?: (args: { title: string; route_link?: string }) => void;
}

const SubNavigation: React.FC<SubNavigationProps> = ({ items, onClick }) => {
  const handleItemClick = (
    e: React.MouseEvent<{}>,
    title: string,
    route_link?: string
  ) => {
    e.preventDefault();
    onClick && onClick({ title, route_link });
  };

  return (
    <div data-testid="subnavigation-wrapper">
      {items &&
        items.map((item, index) => (
          <div key={index} data-testid={`${index}-slot`}>
            <SubNavigationSlot
              data-testid={`subnavigation-slot`}
              item={item}
              onClick={e => handleItemClick(e, item.title, item.route_link)}
            />
          </div>
        ))}
    </div>
  );
};

export default SubNavigation;
